define('modules/page_listing/views/tags_view',['require','exports','module','base/collectionview','./tag_itemview','ldsh!../templates/main'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      TagListItemView = require("./tag_itemview");

  module.exports = CollectionView.extend({
    //fake template
    template: require("ldsh!../templates/main"),
    tagName: "ul",
    className: "ed-tag-list",
    itemView: TagListItemView,
    initialize: function() {
      this.listenTo(this.childVent, "tag:delete", this.removeTag);
      this.listenTo(this.collection, "add remove reset", this._toggle);
    },
    removeTag: function(itemView, nop, tagModel) {
      this.collection.remove(tagModel);
    },
    _toggle: function() {
      this.$el.toggleClass("hidden", !this.collection.length);
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

});

